export default {
  hasNewNotifications (state) {
    return state.notifications.filter(notification => !notification.read_at).length > 0
  }
}
